import React from 'react';
import PropTypes from 'prop-types';
import {getDataAttribute} from 'epic-common/src/browser';

class FooterLinks extends React.PureComponent {
    static propTypes = {
        links: PropTypes.array,
        subTitle: PropTypes.string,
        thin: PropTypes.bool,
        length: PropTypes.number
    };

    onClick = (e) => {
        if (e.button && e.button > 0) return;
        const index = getDataAttribute(e.currentTarget, 'index');
        const link = this.props.links[index];

        if (link && link.onClick && typeof link.onClick === 'function') {
            link.onClick(e);
        }
    };

    renderLinks = (links, startingIndex) => {
        if (!links) return [];
        return links.map((link, i) => {
            return (
                <li key={`item-${link.title}`}>
                    <a
                        onClick={this.onClick}
                        href={link.href || '#'}
                        target={link.target}
                        data-index={startingIndex + i}
                        className={`text-color accent-color-hover ${!link.href ? 'cursor-default' : ''}`}>
                        {link.title}
                    </a>
                </li>
            );
        });
    };

    render() {
        const {subTitle, thin, length} = this.props;
        let links = this.props.links || [];
        if (links && typeof links.asMutable === 'function') {
            links = links.asMutable();
        }

        let one = [];
        let two = [];
        let three = [];

        const len = length || links.length;

        // more than 4 items split in half
        if (len >= 4 && len < 9) {
            const split = Math.ceil(len / 2);
            one = links.slice(0, split);
            two = links.slice(split, len);
        } else if (len > 8) {
            let split = Math.ceil(len / 3);
            one = links.slice(0, split);
            split = Math.ceil(len * 0.666);
            two = links.slice(one.length, split);
            three = links.slice(split, len);
        } else {
            one = links;
        }

        return (
            <div className={`footerLink-wrapper ${thin ? 'thin' : ''} ${one.length ? 'one' : ''} ${two.length ? 'two' : ''} ${three.length ? 'three' : ''}`}>
                <div className="inner-wrap">
                    <div className="subtitle text-color mobile-border-color">
                        <span>{subTitle || ''}</span>
                    </div>

                    {one && one.length > 0 ? (
                        <ul className="footerLinks first-column">
                            { this.renderLinks(one, 0) }
                        </ul>) : ''}
                    {two && two.length > 0 ? (
                        <ul className="footerLinks second-column">
                            { this.renderLinks(two, one.length) }
                        </ul>) : ''}
                    {three && three.length > 0 ? (
                        <ul className="footerLinks third-column">
                            { this.renderLinks(three, one.length + two.length) }
                        </ul>) : ''}
                </div>
            </div>
        );
    }
}

export default FooterLinks;
